var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_c('Kv'),_c('steps',{attrs:{"step":1}}),_c('div',{staticClass:"contents"},[_c('Step1',{attrs:{"searchNumber":_vm.itemArray.length}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }